import styled from 'styled-components';

const TitleMLStyled = styled.div`
  padding: ${(props) => props.p || '32px 0'};
  .title-style {
    color: ${(props) => props.theme.palette.black};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    font-family: SourceHanSansCN;
    font-weight: 500;
    line-height: 1;
  }
  .subtitle-title-style {
    font-size: 12px;
    font-weight: 500;
    color: ${(props) => (props.isError ? '#D10000' : '#999999')};
    line-height: 1;
  }
`;
export default TitleMLStyled;
